import { GtmEvents } from '@/gtm/gtm-events';

export const extendOrderActions = {
  clickExtendBtn: 'ЛК_Заказы_Подробнее_ПродлитьЗаказ',
  successExtend: 'ЛК_Заказы_Подробнее_ЗаказПродлен',
  errorExtend: 'ЛК_Заказы_Подробнее_ПродлитьЗаказОшибка',
};

export class CAccountGtmEvents extends GtmEvents {
  eventCategory = 'СобытияЛК';

  onShowProfilePage() {
    return this.gtmEvent({
      eventAction: 'ЛК_Профиль_ПросмотрСтраницы',
    });
  }

  onShowOrdersPage() {
    return this.gtmEvent({
      eventAction: 'ЛК_Заказы_ПросмотрСтраницы',
    });
  }

  onShowOrderDetails(orderNumber) {
    return this.gtmEvent({
      eventAction: 'ЛК_Заказы_Подробнее_Просмотр',
      eventLabel: orderNumber,
    });
  }

  onClickOrderPayBtn(orderNumber) {
    return this.gtmEvent({
      eventAction: 'ЛК_Заказы_Подробнее_ОплатитьЗаказ',
      eventLabel: orderNumber,
    });
  }

  onClickOrderCancelBtn(orderNumber) {
    return this.gtmEvent({
      eventAction: 'ЛК_Заказы_Подробнее_ОтменитьЗаказ',
      eventLabel: orderNumber,
    });
  }

  onSuccessfullyOrderCanceled(reason) {
    return this.gtmEvent({
      eventAction: 'ЛК_Заказы_Подробнее_ЗаказОтменен',
      eventLabel: reason,
    });
  }

  onClickOrderPrintBtn(orderNumber) {
    return this.gtmEvent({
      eventAction: 'ЛК_Заказы_Подробнее_Печать',
      eventLabel: orderNumber,
    });
  }

  onClickOrderFavouriteBtn(productId) {
    return this.gtmEvent({
      eventAction: 'ЛК_Заказы_Подробнее_ДобавитьВИзбранное',
      eventLabel: productId,
    });
  }

  onClickOrderDetailsCloseBtn() {
    return this.gtmEvent({
      eventAction: 'ЛК_Заказы_Подробнее_Закрыть',
    });
  }

  paidFps({ orderNumber }) {
    return this.gtmEvent({
      eventAction: 'ЛК_Заказы_Подробнее_ЗаказОплаченСБП',
      eventLabel: orderNumber,
    });
  }

  productCardClick(productId) {
    return this.gtmEvent({
      eventAction: 'ЛК_Заказы_Подробнее_ПерейтиВКарточку',
      eventLabel: productId,
    });
  }

  onCloseOrder() {
    return this.gtmEvent({
      eventAction: 'ЛК_Заказы_Подробнее_Вернуться',
    });
  }

  onClickExit() {
    return this.gtmEvent({
      eventAction: 'ЛК_Выход',
    });
  }

  onUpdateFormFields() {
    return this.gtmEvent({
      eventAction: 'ЛК_Профиль_ДанныеИзменить',
    });
  }

  onEditContactField(type, action) {
    const field = {
      phone: {
        edit: 'ЛК_Профиль_ДанныеТелефонИзменить',
        successEdit: 'ЛК_Профиль_ДанныеТелефонИзменен',
      },
      email: {
        edit: 'ЛК_Профиль_ДанныеEmailИзменить',
        successEdit: 'ЛК_Профиль_ДанныеEmailИзменен',
      },
    };

    return this.gtmEvent({
      eventAction: field[type][action],
    });
  }

  onClickProfileUpdateBtn(form, account) {
    const accountForm = {
      ...account,
      cityId: account.city.id,
    };

    const result = {
      firstName: null,
      secondName: null,
      lastName: null,
      birthday: null,
      gender: null,
      cityId: null,
      children: null,
      spouse: {
        gender: null,
        birthday: null,
      },
    };

    const getStatus = (formField, accountField) => {
      if (formField && !accountField) {
        return 'add';
      } if (!formField && accountField) {
        return 'delete';
      } if (formField === accountField) {
        return 'nothing';
      } if (formField !== accountField) {
        return 'change';
      }
    };

    Object.keys(result).forEach((field) => {
      const formField = form[field];
      const accountField = accountForm[field];

      if (field === 'children') {
        const isSimilarArrays = formField.length === accountField.length;
        const formChildren = isSimilarArrays ? JSON.stringify(formField) : formField.length > accountField.length;
        const accountChildren = isSimilarArrays ? JSON.stringify(accountField) : formField.length < accountField.length;

        result.children = getStatus(formChildren, accountChildren);
      } else if (field === 'spouse') {
        result.spouse = {
          gender: getStatus(formField?.gender, accountField?.gender),
          birthday: getStatus(formField?.birthday, accountField?.birthday),
        };
      } else {
        result[field] = getStatus(formField, accountField);
      }
    });

    return this.gtmEvent({
      eventAction: 'ЛК_Профиль_ДанныеИзменены',
      eventLabel: JSON.stringify(result),
    });
  }

  extendOrder(action, data) {
    return this.gtmEvent({
      eventAction: action,
      eventLabel: JSON.stringify(data),
    });
  }
}

export const accountGtmEvents = new CAccountGtmEvents();
